import * as Popover from "@radix-ui/react-popover";
import { DEFAULT_AVATAR } from "@swivl-mono/ui";
import { useEffect, useMemo, useState } from "react";

import { Member } from "../../../Models/Member/Member.Current";
import MembersModel from "../../../Models/Member/Members.Model";

export function MembersOnlineSection() {
  const { availableMembers, membersMap } = MembersModel.useState((s) => s);

  const [isOpen, setIsOpen] = useState(false);
  const membersOnline: number[] | undefined = useMemo(() => {
    if (!availableMembers) {
      return undefined;
    }
    return Object.keys(availableMembers).map(Number);
  }, [availableMembers]);

  useEffect(() => {
    MembersModel.getMembersAvailability();
    const interval = setInterval(() => {
      MembersModel.getMembersAvailability();
    }, 300000); // 5 minutes (300 seconds)
    return () => clearInterval(interval);
  }, []);

  const areMembersOnline = membersOnline && Object.keys(membersOnline).length > 0;

  const handleToggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  if (!membersOnline) {
    return null;
  }

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen} modal={false}>
      {areMembersOnline ? (
        <Popover.Trigger asChild onMouseEnter={handleToggleOpen} onMouseLeave={handleToggleOpen}>
          <div className="flex h-fit items-center gap-2 py-2">
            <span className="text-grey-700">
              {membersOnline.length} agent{membersOnline.length === 1 ? "" : "s"} online
            </span>
          </div>
        </Popover.Trigger>
      ) : (
        <div className="text-center text-grey-700">No agents online</div>
      )}

      <Popover.Content
        side="bottom"
        align="start"
        className="max-h-[80vh] w-max overflow-y-auto rounded-lg bg-grey-800 shadow-lg outline-hidden"
        onMouseEnter={handleToggleOpen}
        onMouseLeave={handleToggleOpen}
      >
        <ul className="divide-y divide-grey-700 rounded-lg bg-inherit text-white">
          {membersOnline.map((memberId) => {
            let agentName = membersMap?.[memberId]?.agentName;
            if (!agentName) {
              console.log("*** Agent name unknown", memberId);
              agentName = "Unknown Member";
            }
            return (
              <li key={memberId} className="flex items-center gap-3 p-3">
                <img
                  src={(membersMap && membersMap[memberId]?.agentAvatarURL) || DEFAULT_AVATAR}
                  alt={`${membersMap && membersMap[memberId]?.agentName} avatar`}
                  className="size-5 rounded-full"
                />
                <span className="text-sm whitespace-nowrap">{agentName}</span>
              </li>
            );
          })}
        </ul>
      </Popover.Content>
    </Popover.Root>
  );
}
